import * as React from 'react'
import { Block, Button } from '$views/components'

interface Props {
  onPreviousStep: () => void
  onNextStep: () => void
  nextButtonLabel: string
}

export const ButtonForm: React.FC<Props> = ({ onPreviousStep, onNextStep, nextButtonLabel }) => {
  return (
    <Block flex>
      <Block marginRight="base">
        <Button primary bordered onClick={onPreviousStep}>
          Volver
        </Button>
      </Block>
      <Button primary fluid onClick={onNextStep}>
        {nextButtonLabel}
      </Button>
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/components/ButtonForm.tsx